export default __webpack_public_path__ + "static/media/javascript.9432c09a.svg";